import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const IconButton = ({ className, icon, label, size, count, ...rest }) => {
    const iconRender = typeof icon === "string" ? _jsx(Icon, { size: "m", name: icon }) : icon;
    return (_jsxs("div", { className: "eds-button--icon__wrapper", children: [!!count && _jsx("span", { className: "eds-button--icon__count", children: count }), _jsxs(Button, { size: size, className: classNames("eds-button--icon", className), ...rest, children: [iconRender, _jsx("span", { className: "eds-hidden--screen-reader-only", children: label })] })] }));
};
